import { Polyline } from 'react-leaflet';
import { LatLngTuple } from 'leaflet';
import { DEFAULT_ROUTE_COLOR } from '../utils/mapColors';

interface RoutePolylineProps {
  /**
   * Route coordinates as [lat, lng] tuples
   */
  positions: LatLngTuple[];
  /**
   * Route color
   * @default DEFAULT_ROUTE_COLOR (blue-500)
   */
  color?: string;
  /**
   * Enable animated dash effect
   * @default true
   */
  animated?: boolean;
  /**
   * Line opacity
   * @default 0.8
   */
  opacity?: number;
  /**
   * Line weight (thickness in pixels)
   * @default 4
   */
  weight?: number;
}

/**
 * Route polyline component for displaying routes on the map
 * Supports color coding and optional dash animation
 */
export function RoutePolyline({
  positions,
  color = DEFAULT_ROUTE_COLOR,
  animated = true,
  opacity = 0.8,
  weight = 4,
}: RoutePolylineProps) {
  return (
    <Polyline
      positions={positions}
      pathOptions={{
        color,
        weight,
        opacity,
        dashArray: animated ? '10, 10' : undefined,
        className: animated ? 'animate-dash' : undefined,
      }}
    />
  );
}
